export const state = () => ({
  locale: process.env.VUE_APP_LANG ?? 'es',
})
